import React, { useContext } from "react";
import { isMobile } from "react-device-detect";
import { MOUSE_ASSIGNABLE_TOOL_NAMES } from "../../../../../constants/MouseButtonToolAssignments";
import themeContext from "../../../../../context/theme/ThemeContext";

export function createMouseButtonAssignmentPointerDownCaptureHandler(
  toolName,
  assignMouseButtonToAssignableTool
) {
  return (event) => {
    if (isMobile) {
      return;
    }
    if (event.pointerType && event.pointerType !== "mouse") {
      return;
    }
    if (!MOUSE_ASSIGNABLE_TOOL_NAMES.includes(toolName)) {
      return;
    }
    let slot = null;
    if (event.button === 1) {
      event.preventDefault();
      slot = "auxiliary";
    } else if (event.button === 2) {
      event.preventDefault();
      slot = "secondary";
    }
    if (!slot) {
      return;
    }
    assignMouseButtonToAssignableTool(slot, toolName);
  };
}

/** @deprecated Use createMouseButtonAssignmentPointerDownCaptureHandler + onPointerDownCapture */
export const createMouseButtonAssignmentMouseDownHandler =
  createMouseButtonAssignmentPointerDownCaptureHandler;

export function suppressMouseButtonAssignmentContextMenu(event) {
  event.preventDefault();
}

export function ToolbarMouseAssignmentIndicators({ toolName, assignments }) {
  const { theme } = useContext(themeContext) || {};

  if (!assignments || !MOUSE_ASSIGNABLE_TOOL_NAMES.includes(toolName)) {
    return null;
  }
  const showL = assignments.primary === toolName;
  const showR = assignments.secondary === toolName;
  const showM = assignments.auxiliary === toolName;
  if (!showL && !showR && !showM) {
    return null;
  }
  return (
    <div
      className="toolbar-mouse-assignment-slots"
      style={{
        "--mouse-button-base-color": theme?.palette?.inactiveTool,
        "--mouse-button-active-color": theme?.palette?.activeTool,
      }}
      aria-hidden
    >
      {showL && (
        <div className="mouse-icon mouse-left-button"></div>
      )}
      {showM && (
        <div className="mouse-icon mouse-middle-button"></div>
      )}
      {showR && (
        <div className="mouse-icon mouse-right-button"></div>
      )}
    </div>
  );
}
